<div class="settings-page">
<div class="settings-tabs">
  <button class="tab-btn" [class.active]="activeTab === 'settings'" (click)="setActiveTab('settings')">
    Settings
  </button>

  <button class="tab-btn" [class.active]="activeTab === 'roles'" (click)="setActiveTab('roles')">
    User Roles
  </button>
</div>


<div class="settings-wrapper">

  @if (activeTab === 'settings') {
    <div>
      <!-- Action Buttons -->
      <div class="action-buttons">
        <div class="action-card">
          <div class="action-card-info">
            <div class="action-icon force-upgrade">
              <i class="pi pi-arrow-up-right"></i>
            </div>
            <div>
              <h4>Force Upgrade</h4>
              <p>Require all users to download the newest version of the app.</p>
            </div>
          </div>
          <button class="toggle-btn" [class.toggle-btn-on]="forceUpgradeEnabled()" (click)="onForceUpgradeToggle()">
            <span class="toggle-thumb"></span>
            <span class="toggle-label">{{ forceUpgradeEnabled() ? 'Enabled' : 'Disabled' }}</span>
          </button>
        </div>
        <div class="action-card">
          <div class="action-card-info">
            <div class="action-icon maintenance">
              <i class="pi pi-wrench"></i>
            </div>
            <div>
              <h4>Maintenance Mode</h4>
              <p>Display a maintenance banner to all users across the app.</p>
            </div>
          </div>
          <button class="toggle-btn" [class.toggle-btn-on]="maintenanceEnabled()" (click)="onMaintenanceToggle()">
            <span class="toggle-thumb"></span>
            <span class="toggle-label">{{ maintenanceEnabled() ? 'Enabled' : 'Disabled' }}</span>
          </button>
        </div>
        <div class="action-card">
          <div class="action-card-info">
            <div class="action-icon maintenance">
              <i class="pi pi-bolt"></i>
            </div>
            <div>
              <h4>Early Release</h4>
              <p>Shows a banner on the landing page and login screen letting users know that the app is in "Early Release"
              and there may be bugs.</p>
            </div>
          </div>
          <button class="toggle-btn" [class.toggle-btn-on]="earlyReleaseEnabled()" (click)="onEarlyReleaseToggle()">
            <span class="toggle-thumb"></span>
            <span class="toggle-label">
              {{ earlyReleaseEnabled() ? 'Enabled' : 'Disabled' }}
            </span>
          </button>
        </div>
        <div class="action-card" style="opacity: 0.5; pointer-events: none;">
          <div class="action-card-info">
            <div class="action-icon beta-release">
              <i class="pi pi-star"></i>
            </div>
            <div>
              <h4>Beta Release</h4>
              <p>Enable early access to new features for selected users before public release. (Disabled for Phase 2)</p>
            </div>
          </div>
          <button class="toggle-btn" [class.toggle-btn-on]="betaReleaseEnabled()" (click)="onBetaReleaseToggle()"
            disabled>
            <span class="toggle-thumb"></span>
            <span class="toggle-label">{{ betaReleaseEnabled() ? 'Enabled' : 'Disabled' }}</span>
          </button>
        </div>
        <div class="action-card">
          <div class="action-card-info">
            <div class="action-icon advertisements">
              <i class="pi pi-images"></i>
            </div>
            <div>
              <h4>App Advertisements</h4>
              <p>Will display Google Play store link and Brand Image with category "Advertisment".</p>
            </div>
          </div>
          <button class="toggle-btn" [class.toggle-btn-on]="appAdvertisementsEnabled()"
            (click)="onAppAdvertisementsToggle()">
            <span class="toggle-thumb"></span>
            <span class="toggle-label">{{ appAdvertisementsEnabled() ? 'Enabled' : 'Disabled' }}</span>
          </button>
        </div>
        <div class="action-card" style="opacity: 0.5; pointer-events: none;">
          <div class="action-card-info">
            <div class="action-icon global-logout">
              <i class="pi pi-power-off"></i>
            </div>
            <div>
              <h4>Force Global Logout</h4>
              <p>Will terminate all active user sessions immediately. Admin sessions will be terminated after 30 minutes.
              Users cannot log back in until disabled. (Disabled for Phase 2)</p>
            </div>
          </div>
          <button class="toggle-btn" [class.toggle-btn-on]="systemOutageEnabled()" (click)="onSystemOutageToggle()"
            disabled>
            <span class="toggle-thumb"></span>
            <span class="toggle-label">{{ systemOutageEnabled() ? 'Enabled' : 'Disabled' }}</span>
          </button>
        </div>
        <div class="action-card">
          <div class="action-card-info">
            <div class="action-icon pwa-installer">
              <i class="pi pi-download"></i>
            </div>
            <div>
              <h4>PWA Installer</h4>
              <p>When enabled, users will see the PWA installation prompt.</p>
            </div>
          </div>
          <button class="toggle-btn" [class.toggle-btn-on]="pwaInstallerEnabled()" (click)="onPwaInstallerToggle()">
            <span class="toggle-thumb"></span>
            <span class="toggle-label">{{ pwaInstallerEnabled() ? 'Enabled' : 'Disabled' }}</span>
          </button>
        </div>
        <div class="action-card" style="opacity: 0.5; pointer-events: none;">
          <div class="action-card-info">
            <div class="action-icon suspend-ai">
              <i class="pi pi-ban"></i>
            </div>
            <div>
              <h4>Suspend AI Services</h4>
              <p>Temporarily disable cost-heavy or buggy AI matching and safety services. (Disabled for Phase 2)</p>
            </div>
          </div>
          <button class="toggle-btn" [class.toggle-btn-on]="suspendAiServicesEnabled()"
            (click)="onSuspendAiServicesToggle()" disabled>
            <span class="toggle-thumb"></span>
            <span class="toggle-label">{{ suspendAiServicesEnabled() ? 'Enabled' : 'Disabled' }}</span>
          </button>
        </div>
        <div class="action-card">
          <div class="action-card-info">
            <div class="action-icon freeze-registrations">
              <i class="pi pi-user-minus"></i>
            </div>
            <div>
              <h4>Freeze Registrations</h4>
              <p>Prevent new users from signing up to the app.</p>
            </div>
          </div>
          <button class="toggle-btn" [class.toggle-btn-on]="freezeRegistrationsEnabled()"
            (click)="onFreezeRegistrationsToggle()">
            <span class="toggle-thumb"></span>
            <span class="toggle-label">{{ freezeRegistrationsEnabled() ? 'Enabled' : 'Disabled' }}</span>
          </button>
        </div>
      </div>
    </div>
  }

  @if (isSuperAdmin() && activeTab === 'roles') {
    <div class="section-header">
      <h3 class="section-title">
        <i class="pi pi-shield me-2" style="margin-right: 12px;"></i>
        User Role Management
      </h3>
      <p class="section-subtitle">Manage and update user role</p>
    </div>

    <!-- Search bar -->
    <div class="role-table-toolbar d-flex align-items-center justify-content-between">
      <app-search-box tooltipText="Search By firstName, lastName, and email" (search)="onSearch($event)" />
      @if (hasSelection()) {
        <button class="btn btn-change-role d-inline-flex align-items-center gap-2" (click)="onBulkRoleChange()">
          <i class="pi pi-user"></i> Bulk User
        </button>
      }
    </div>

    <div class="table-container">
      <table class="role-table">
        <colgroup>
        <col style="width: 44px">
        <col style="width: 20%">
        <col style="width: 25%">
        <col style="width: 15%">
        <col style="width: 20%">
        <col style="width: 170px">
      </colgroup>
      <thead class="table-headings">
        <tr>
          <th class="checkbox-col"><input type="checkbox" [checked]="allSelected()"
          (change)="toggleSelectAll($event)" /></th>
          <th class="sortable" (click)="onSort('firstName')">
            Name <span class="sort-indicator">{{ getSortIcon('firstName') }}</span>
          </th>
          <th class="sortable" (click)="onSort('email')">
            Email <span class="sort-indicator">{{ getSortIcon('email') }}</span>
          </th>
          <th class="sortable" (click)="onSort('role')">
            Current Role <span class="sort-indicator">{{ getSortIcon('role') }}</span>
          </th>
          <th class="sortable" (click)="onSort('lastActive')">
            Last Active <span class="sort-indicator">{{ getSortIcon('lastActive') }}</span>
          </th>

          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody class="setting-body">
        @if (roleLoader()) {
          <tr>
            <td colspan="6" class="centered-cell">
              <app-spinner-loader [width]="35" />
            </td>
          </tr>
        } @else if (adminUsers().length === 0) {
          <tr>
            <td colspan="6" class="no-data-cell">No users found</td>
          </tr>
        } @else {
          @for (user of adminUsers(); track user) {
            <tr [class.selected]="user.selected">
              <td class="checkbox-col">
                <input type="checkbox" [checked]="user.selected" (change)="toggleSelection(user, $event)" />
              </td>
              <td>
                <div class="d-flex align-items-center gap-2">
                  <div class="user-avatar" [class.avatar-img-wrap]="getProfileImage(user)"
                    [style.cursor]="getProfileImage(user) ? 'pointer' : 'default'"
                    (click)="getProfileImage(user) && openPreview(getProfileImage(user)!)">
                    @if (getProfileImage(user)) {
                      <img [src]="getProfileImage(user)" alt="Profile" class="avatar-photo" />
                    }
                    @if (!getProfileImage(user)) {
                      <span>
                        {{ getInitials(user) }}
                      </span>
                    }
                  </div>
                  <span class="fw-semibold text-clip" [pTooltip]="getDisplayName(user)" tooltipPosition="top">{{
                  getDisplayName(user) | titlecase}}</span>
                </div>
              </td>
              <td class="text-muted">
                <span class="email-clip" [pTooltip]="user.email" tooltipPosition="top">{{ user.email }}</span>
              </td>
              <td>
                <span class="role-badge" [ngClass]="getRoleBadgeClass(user.role)">
                  {{ user.role }}
                </span>
              </td>
              <td class="text-muted">{{ user.lastLoginAt ? (user.lastLoginAt | date:'MM-dd-yyyy') : 'N/A' }}</td>
              <td class="text-center">
                <button class="btn btn-view d-inline-flex align-items-center gap-2" (click)="openRoleDialog(user)">
                  Edit
                </button>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>

    <!-- Pagination footer -->
    <div class="table-footer">
      <span class="entries-info">
        Showing {{ startIndex }} to {{ endIndex }} of {{ totalCount() }} Entries
      </span>
      <div class="pagination-controls">
        <span class="page-size-label">Page Size:</span>
        <select class="page-size-select" [value]="pageSize()" (change)="onPageSizeChange(+$any($event.target).value)">
          @for (size of pageSizes; track size) {
            <option [value]="size">{{ size }}</option>
          }
        </select>
        <button class="btn-page" (click)="previousPage()" [disabled]="currentPage() === 1">&lt; Prev</button>
        <button class="btn-page" (click)="nextPage()" [disabled]="currentPage() === totalPages">Next &gt;</button>
      </div>
    </div>
  </div>
}
<app-role-change-dialog [user]="selectedUser()" [isVisible]="roleDialogVisible()" (close)="closeRoleDialog()"
  (roleChanged)="onRoleChanged($event)">
</app-role-change-dialog>
</div>
@if (previewPopupUrl()) {
  <div class="img-preview-backdrop" (click)="closePreview()">
    <div class="img-preview-box" (click)="$event.stopPropagation()">
      <button class="img-preview-close" (click)="closePreview()">
        <i class="fa-solid fa-xmark"></i>
      </button>
      <img [src]="previewPopupUrl()!" alt="Preview" class="img-preview-full" />
    </div>
  </div>
}
</div>